import { useQuery } from "react-query";

import { getClassCurationsDetailApi, getClassPublicCurationDetailApi } from "./api";

export const useGetClassCurationsDetailApiQuery = (isLogin: boolean, curationId?: string) => {
  return useQuery(
    ["classCurationsDetailApi", isLogin, curationId],
    () => getClassCurationsDetailApi({ curationId: curationId }),
    {
      enabled: !!curationId && isLogin,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
  );
};

export const useGetClassPublicCurationsDetailApiQuery = (curationId?: string) => {
  return useQuery(
    ["classPublicCurationsDetailApi", curationId],
    () => getClassPublicCurationDetailApi({ curationId: curationId }),
    {
      enabled: !!curationId,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
  );
};
